import Toasted from "vue-toasted";
import Vue from "vue";
import instanceAxios from '../services/AxiosApi'
import store from '../store';

Vue.use(Toasted);

const zero = {
  ajax: async (options) => {

    return instanceAxios.request(options)
      .then((response) => {
        return zero.procesaResponse(response, options)
      }).catch((reject) => {
        return zero.procesarError(reject)
      });
  },
  procesaResponse: (response, options) => {
    //console.log('PETICIÓN A => ' + options.baseURL + (options.url || ''))
    return Promise.resolve(response)
  },
  procesarError: (error) => {
    if (!error.response) {
      zero.showError('El servidor no se encuentra disponible.')
    }
    if (!error.response) {
      return Promise.reject({
        mensaje: 'No se recibio respuesta'
      })
    }
    let status = error.response.status;

    //BAD REQUEST
    if (status == 400 && error.response.data.validaciones) {
      zero.mostrarValidaciones(error.response.data.validaciones)
      return Promise.reject({
        mensaje: 'Validación'
      })
    }
    //BAD REQUEST
    if (status == 400) {
      zero.showError(error.response.data.mensaje)
    }
    //DEMASIADAS SOLICITUDES
    if (status == 429) {
      zero.showError('Ha alcanzado el número maximo de solicitudes. Espere 1 minuto para volver a intentarlo.')
    }
    //FORBIDDEN 
    if (status == 403) {
      zero.showError('No tiene permiso para acceder al recurso.')
    }
    //No Autenticado
    if (status == 401) {
      store.commit('auth/logOut');
      //zero.showError('Debe iniciar sesión.')
    }
    //NO EXISTE EL RECURSO
    if (status == 404) {
      zero.showError('No existe el recurso solicitado.')
    }
    //NO EXISTE EL RECURSO
    if (status == 500) {
      zero.showError('Lo lamentamos, ha ocurro un error. Inténtelo más tarde.')
    }
    //VALIDACIONES
    if (status == 422) {
      zero.showErrors(error.response.data.errors)
    }
    return Promise.reject({
      mensaje: 'Bad request'
    })
  },
  showError: (mensaje) => {
    Vue.toasted.show(mensaje, {
      theme: "toasted-primary",
      position: "top-center",
      duration: 5000,
      type: "error",
    });
  },
  showSuccess: (mensaje) => {
    Vue.toasted.show(mensaje, {
      theme: "toasted-primary",
      position: "top-center",
      duration: 5000,
      type: "success",
    });
  },
  mostrarValidaciones: (validaciones) => {
    let mensaje = '<ul class="list-group">';
    validaciones.forEach((validacion) => {
      mensaje += '<li class="list-group-item">' + validacion + "</li>";
    });
    mensaje += "</ul>";
    Vue.toasted.show(mensaje, {
      theme: "toasted-primary",
      position: "top-center",
      duration: 5000,
      type: "warning",
    });
  },
  showMessages: (messages) => {
    let mensaje = '<ul class="list-group">';
    messages.forEach((element) => {
      mensaje += '<li class="list-group-item">' + element + "</li>";
    });
    mensaje += "</ul>";
    Vue.toasted.show(mensaje, {
      theme: "toasted-primary",
      position: "top-center",
      duration: 5000,
      type: "default",
    });
  },
  showValidations: (validations) => {
    let mensaje = '<ul class="list-group">';
    validations.forEach((element) => {
      mensaje += '<li class="list-group-item">' + element + "</li>";
    });
    mensaje += "</ul>";
    Vue.toasted.show(mensaje, {
      theme: "toasted-primary",
      position: "top-center",
      duration: 5000,
      type: "error",
    });
  },
  clearFields: () => {
    let inputs = document.querySelectorAll('input[type="text"]');
    for (let i = 0; i < inputs.length; i++) {
      inputs[i].value = "";
    }
    let files = document.querySelectorAll('input[type="file"]');
    for (let i = 0; i < files.length; i++) {
      files[i].value = "";
    }
  },
};
export default zero;
